module.exports = __webpack_public_path__ + "static/media/23_winewhiskey.818c14c2.jpg";